import { FormFieldComponentProps } from "../components/new_form/form_fields/FormFieldComponent";
import { getSession } from "../helper";
import { LIST_LIFE_DOMAINS } from "./routes";

export function getLifeDomainForm(): FormFieldComponentProps[] {
  return [
    {
      type: "text",
      required: true,
      placeholder: "Life Domain Name",
      key: "name",
      label: "Name",
    },
    {
      type: "query_dropdown",
      required: false,
      key: "parentLifeDomainId",
      label: "Parent Life Domain",
      noSelectionLabel: "No Parent Life Domain",
      apiCall: {
        documentNode: LIST_LIFE_DOMAINS,
        key: "listLifeDomains",
      },
      apiVariables: {
        session: getSession(),
      },
    },
  ];
}
